<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>任务详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div style="font-size:18px;color:black">
        <i class="el-icon-collection-tag" style="color:#09afff;font-size:18px;" />
        <span class="font-small">任务信息</span>
      </div>

      <div class="table-layout">
        <el-row>
          <el-col :span="3" class="table-cell-title">任务编号</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.taskNo }}</el-col>
          <el-col :span="3" class="table-cell-title">任务名称</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.taskName }}</el-col>
          <el-col :span="3" class="table-cell-title">任务类型</el-col>
          <el-col :span="5" class="table-cell">{{ taskType[taskInfo.taskType] }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="3" class="table-cell-title">关联服务者</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.workerName }}</el-col>
          <el-col :span="3" class="table-cell-title">关联业务号</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.rNo }}</el-col>
          <el-col :span="3" class="table-cell-title">关联线索</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.clueNo }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">当前处理人</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.handleName }}</el-col>
          <el-col :span="3" class="table-cell-title">任务备注</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.content }}</el-col>
          <el-col :span="3" class="table-cell-title">任务状态</el-col>
          <el-col :span="5" class="table-cell">{{ taskStateMap[taskInfo.state] }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">创建时间</el-col>
          <el-col :span="5" class="table-cell">{{ formateTime(taskInfo.createTime) }}</el-col>
          <el-col :span="3" class="table-cell-title">跟进时间</el-col>
          <el-col :span="5" class="table-cell">{{ formateTime(taskInfo.followupTime) }}</el-col>
          <el-col :span="3" class="table-cell-title">是否超时</el-col>
          <el-col :span="5" class="table-cell">{{ taskInfo.isTimeout == 1 ? '是' : '否' }}</el-col>
        </el-row>
      </div>

      <el-row style="text-align:center;margin-top:20px;">
        <el-button type="primary" icon="el-icon-add" @click="toAddActionLog()">添加记录</el-button>
        <el-button type="primary" v-if="taskInfo.state==1||taskInfo.state==2" @click="toUpdateTaskRemark()">修改任务备注</el-button>
        <el-button type="success" v-if="taskInfo.state==2"  @click="finishOrCancelTask(3)">完成任务</el-button>
        <el-button type="primary" v-if="taskInfo.state==1||taskInfo.state==2" @click="deliverTask()">任务流转</el-button>
        <el-button type="warning" v-if="taskInfo.state==1||taskInfo.state==2" icon="el-icon-close" @click="finishOrCancelTask(4)">取消任务</el-button>
      </el-row>


      <div style="font-size:18px;margin-top:20px;color:black">
        <i class="el-icon-collection-tag" style="color:#09afff;font-size:18px;" />
        <span class="font-small">线索信息</span>
      </div>

      <div class="table-layout">
        <el-row>
          <el-col :span="3" class="table-cell-title">线索编号</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.clueNo }}</el-col>
          <el-col :span="3" class="table-cell-title">线索名称</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.workerName }}</el-col>
          <el-col :span="3" class="table-cell-title">手机号码</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.tel }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">城市</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.cityName }}</el-col>
          <el-col :span="3" class="table-cell-title">驿站</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.cityDto ? clueInfo.cityDto.postStationName : '' }}</el-col>
          <el-col :span="3" class="table-cell-title">服务站</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.cityDto ? clueInfo.cityDto.stationName : '' }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="3" class="table-cell-title">线索来源</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.sourceRelationName }}</el-col>
          <el-col :span="3" class="table-cell-title">线索归属</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.workerBelongName }}</el-col>
          <el-col :span="3" class="table-cell-title">工种</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.workerType | filterWorkerType(clueInfo.workerType)
          }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">身份证</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.idCard }}</el-col>
          <el-col :span="3" class="table-cell-title">线索状态</el-col>
          <el-col :span="5" class="table-cell">{{ clueState[clueInfo.state] }} ({{ subState[clueInfo.subState]
          }})</el-col>
          <el-col :span="3" class="table-cell-title">面试状态</el-col>
          <el-col :span="5" class="table-cell">{{ ivStateMap[clueInfo.ivState] }} ({{ ivSubStateMap[clueInfo.ivSubState]
          }})</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">年龄</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.age }}</el-col>
          <el-col :span="3" class="table-cell-title">微信号</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.wxAccount }}</el-col>
          <el-col :span="3" class="table-cell-title">当前所在地</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.currentAddress }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">渠道对接人</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.sourceRelationPerson }}</el-col>
          <el-col :span="3" class="table-cell-title">户口</el-col>
          <el-col :span="5" class="table-cell">{{ residenceTypeMap[clueInfo.residenceType] }}</el-col>
          <el-col :span="3" class="table-cell-title">社保</el-col>
          <el-col :span="5" class="table-cell">{{ socialSecurityMap[clueInfo.socialSecurity] }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">当前城市、地址 </el-col>
          <el-col :span="5" class="table-cell">{{ getcityName(clueInfo.currentCity) }} {{ clueInfo.currentAddress
          }}</el-col>
          <el-col :span="3" class="table-cell-title">期望收入</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.salaryHope }}</el-col>
          <el-col :span="3" class="table-cell-title">职位兴趣</el-col>
          <el-col :span="5" class="table-cell">{{ clueInfo.positionInterest }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">求职意向</el-col>
          <el-col :span="5" class="table-cell">{{ getqzyx(clueInfo.joinDemand) }}</el-col>
        </el-row>
      </div>
      <el-row style="text-align:center;margin-top:20px;">
        <el-button type="primary" v-if="clueInfo.state == 2  && (clueInfo.ivState==0||clueInfo.ivSubState==2)" icon="el-icon-user" @click="handleInterview(clueInfo)">发起面试</el-button>
        <el-button type="primary" v-if="clueInfo.state == 2 || clueInfo.state == 1" v-per="'xiansuoluru'" icon="el-icon-user" @click="handleUpdate(clueInfo)">修改线索</el-button>
        <el-button type="success" v-if="clueInfo.state==2 && clueInfo.ivState==3"  v-per="'xiansuoyaoyue'" icon="el-icon-key" @click="handleOffice(clueInfo)">邀请上线</el-button>
        <el-button type="primary" v-if="clueInfo.state == 2 || clueInfo.state == 1"  icon="el-icon-key" @click="addClueTask(clueInfo)">添加线索任务</el-button>
        <el-button type="warning"  v-if="clueInfo.state == 2 || clueInfo.state == 1"  v-per="'xiansuoliushi'" icon="el-icon-close" @click="handleLoss(clueInfo)">流失</el-button>
      </el-row>

      <el-tabs style="height: 320px;">
        <el-tab-pane label="面试信息">
          <div class="table-layout">
            <el-table :data="interviewListAll" border class="table">
              <el-table-column prop="id" width="100" label="id" fixed></el-table-column>
              <el-table-column prop="interviewNo" label="面试编号"></el-table-column>
              <el-table-column prop="interviewName" label="面试名称"></el-table-column>
              <el-table-column prop="workerNo" label="面试者编号"></el-table-column>
              <el-table-column prop="workerName" label="面试者"></el-table-column>
              <el-table-column prop="interviewerName" label="面试官"></el-table-column>
              <el-table-column prop="address" label="地址"></el-table-column>
              <el-table-column prop="interviewTitle" label="面试标题"></el-table-column>
              <el-table-column prop="interviewContent" label="面试内容"></el-table-column>
              <el-table-column prop="interviewTime" label="面试时间" :formatter="dateFormat"></el-table-column>
              <el-table-column prop="relationClueId" label="关联线索id"></el-table-column>
              <el-table-column prop="relationTaskId" label="关联任务id"></el-table-column>
              <el-table-column prop="status" label="面试状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status != ''">{{ ivStateMap[scope.row.status] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="面试结果">
                <template slot-scope="scope">
                  <span v-if="scope.row.subStatus != ''">{{ ivSubStateMap[scope.row.subStatus] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="取消面试类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.cancelReasonType != ''">{{ cancelTypeList[scope.row.cancelReasonType - 1].label
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cancelReason" label="取消原因"></el-table-column>

              <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
              <el-table-column prop label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-check" @click="finishInterview(scope.row)"
                    v-if="scope.row.status == 2">完成面试</el-button>
                  <el-button type="text" icon="el-icon-delete" @click="cancelInterview(scope.row)" class="red"
                    v-if="scope.row.status == 1 || scope.row.status == 2">取消面试</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="任务操作记录">
          <div class="table-layout">
            <el-table :data="taskActionList" border style="width: 100%;overflow:auto" height="300" class="table">
              <el-table-column prop="taskId" width="100" label="关联任务id"></el-table-column>
              <el-table-column prop="comment" label="内容"></el-table-column>
              <el-table-column prop="handleName" label="操作人" width="100"></el-table-column>
              <el-table-column prop="createTime" :formatter="dateFormatA" width="150" label="操作时间"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="线索相关任务">
          <div class="table-layout">
            <el-table :data="taskList" border class="table">
              <el-table-column prop="id" width="80" label="id" fixed></el-table-column>
              <el-table-column prop="taskNo" label="任务编号"></el-table-column>
              <el-table-column prop="taskName" label="任务名称"></el-table-column>
              <el-table-column prop="cityName" label="城市"></el-table-column>
              <el-table-column prop="type" label="任务类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.taskType == 1">线索任务</span>
                  <span v-if="scope.row.taskType == 2">面试任务</span>
                </template>
              </el-table-column>
              <el-table-column prop="clueNo" label="线索编号"></el-table-column>
              <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
              <el-table-column prop="workerName" label="服务者姓名"></el-table-column>
              <el-table-column prop="isOpen" label="状态">
                <template slot-scope="scope">
                  {{ taskStateMap[scope.row.state] }}
                </template>
              </el-table-column>
              <el-table-column prop="timeout" label="超时时间" :formatter="dateFormat">
              </el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
              <el-table-column prop label="操作" fixed="right" width="120">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-view" v-if="scope.row.taskNo != taskNo"
                    @click="showNewTask(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

      <br /><br /><br /><br />
    </el-card>

    <!--新增修改线索 -->
    <workerClueAddFormNew ref="workerClueAddFormNewRef" />
    <!-- 发起面试 -->
    <interviewAddForm ref="interviewRef" />
    <!--线索流失 -->
    <leaveLossForm ref="leaveLossFormRef" />
    <!--添加线索任务 -->
    <clueTaskAdd ref="clueTaskAddRef" />


    <!--添加跟进记录-->
    <addActionLog ref="addActionLogRef" />
    <!--修改任务备注-->
    <updateTaskremark ref="updateTaskremarkRef" />
    <!--修改任务备注-->
    <finishOrCancelTask ref="finishOrCancelTaskRef" />
    <!--任务流转-->
    <deliverTask ref="deliverTaskRef" />


    <!-- 完成面试 -->
    <complateInterview ref="complateInterviewRef" />
    <!--取消面试-->
    <cancelInterview ref="cancelInterviewRef" />

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";

import leaveLossForm from "@/components/workercrm/compent/leaveLossForm.vue";
import workerClueAddFormNew from "@/components/workercrm/compent/workerClueAddFormNew.vue";
import interviewAddForm from "@/components/workercrm/compent/interviewAddForm.vue";
import clueTaskAdd from "@/components/workercrm/compent/clueTaskAdd.vue";

import addActionLog from "@/components/task/taskopert/addActionLog.vue";
import updateTaskremark from "@/components/task/taskopert/updateTaskremark.vue";
import finishOrCancelTask from "@/components/task/taskopert/finishOrCanelTask.vue";
import deliverTask from "@/components/task/taskopert/deliverTask.vue";

import cancelInterview from "@/components/task/cancelInterview.vue";
import complateInterview from "@/components/task/complateInterview.vue";

import { validateIdNo } from "@/script/validator";

let vm;
export default {
  components: {
    Pagination, leaveLossForm, workerClueAddFormNew, interviewAddForm, clueTaskAdd,
    addActionLog, updateTaskremark, finishOrCancelTask, deliverTask,
    cancelInterview, complateInterview
  },

  filters: {
    filterWorkerType(type) {
      if (type == 1) return "保洁";
      if (type == 2) return "保姆";
      if (type == 3) return "品类";
    }
  },
  data() {
    return {
      taskNo: "",
      sourceTypeMap: { 1: "外部渠道", 3: "自招", 4: "转介绍", 7: "自有渠道" },
      taskDetail: {},

      clueInfo: {},
      interviewListAll: [],
      taskActionList: [],
      taskInfo: {},
      taskList: [],
      residenceTypeMap: { 1: "农村", 2: "城镇" },
      socialSecurityMap: { 1: "社保", 2: "新农保", 3: "已退休", 4: "无" },

      taskType: {
        1: "线索任务",
        2: '面试任务'
      },
      taskStateMap: {
        1: '待分配', 2: '处理中', 3: '处理完成', 4: '取消'
      },
      clueLogState: {
        1: "解约",
        2: "流失",
        3: "线索录入-待分配",
        4: "线索分配-跟进中",
        5: "线索跟进成功",
        6: "发起上线审批",
        7: "上线审批结果",
        8: "复职"
      },
      clueState: {
        1: "待分配",
        2: "跟进中",
        3: "跟进成功",
        4: "跟进失败",
        5: "上线失败",
        6: "跟单失败",
        7: "培训失败"
      },
      subState: {
        1: '培训中', 2: '跟单中', 5: '上线失败', 8: '上线成功'
      },
      ivStateMap: {
        1: "待确认",
        2: "待面试",
        3: "已面试",
        4: "面试取消",
      },
      ivSubStateMap: {
        1: "面试通过",
        2: "需再次面试",
        3: "面试淘汰",
      },
      cancelTypeList: [
        {
          value: 1,
          label: '面试者原因'
        },
        {
          value: 2,
          label: '面试官原因'
        },
        {
          value: 3,
          label: '其他原因'
        },
      ],
      curHandlerId: globalData.userInfo.id,
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" }
      ],
      cityList: []
    };
  },
  watch: {
    $route(to, from) { }
  },
  activated() {
    this.taskNo = this.$route.query.taskNo;
    this.querySearch();
  },
  created() {
    // this.querySearch();
  },
  methods: {
    finishInterview(row) {
      this.$refs.complateInterviewRef.finishInterview(row); 
    },
    
    cancelInterview(row) {
      this.$refs.cancelInterviewRef.cancelInterview(row); 
    },
    showNewTask(row) {
      this.$confirm("是否加载线索：" + row.taskNo + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.taskNo=row.taskNo;
          this.querySearch();
        })
        .catch(() => { });
    },
    addClueTask(row) {
      //添加线索任务
      this.$refs.clueTaskAddRef.showAdd(row);
    },
    handleUpdate(row) {
      //修改线索
      this.$refs.workerClueAddFormNewRef.toUpdate(row, 2);
    },
    handleInterview(row) {
      //发起面试
      this.$refs.interviewRef.init(row);
    },
    handleOffice(row) {
      //邀约
      this.$refs.workerClueAddFormNewRef.toUpdate(row, 3);
    },
    handleLoss() {
      //线索流失
      this.$refs.leaveLossFormRef.leaveLossClick(this.clueInfo, 2, 4);
    },
    toAddActionLog() {
      //添加跟进记录
      this.$refs.addActionLogRef.showadd(this.taskInfo);
    },
    toUpdateTaskRemark() {
      //修改任务备注
      this.$refs.updateTaskremarkRef.showUpdate(this.taskInfo);
    },
    finishOrCancelTask(state) {
      //完成或取消任务
      this.$refs.finishOrCancelTaskRef.showOper(this.taskInfo, state);
    },
    deliverTask() {
      //任务流转
      this.$refs.deliverTaskRef.deliverOper(this.taskInfo);
    },
    getqzyx(val) {
      if (val == null || val == "") {
        return;
      }
      return val
        .replace("1", "保洁")
        .replace("2", "保姆")
        .replace("3", "品类");
    },
    querySearch(taskNo) { 
      taskApi.$axiosGetTaskInfo({ taskNo:this.taskNo }).then(res => {
        this.taskDetail = res.data.data;

        this.clueInfo = res.data.data.clueInfo;
        this.interviewListAll = res.data.data.interviewListAll;
        this.taskActionList = res.data.data.taskActionList;
        this.taskInfo = res.data.data.taskInfo;
        this.taskList = res.data.data.taskList;
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getcityName(id) {
      let nm = "";
      this.cityList.forEach(e => {
        if (e.id == id) {
          nm = e.cityName;
        }
      })
      return nm;
    },
    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined || date == "") {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    beforeCreate() {
      vm = this;
    }
  }
};
</script>
<style scoped>
.font-small {
  color: #09afff;
}

.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}

.detail-container {
  width: 80%;
  padding: 20px 20px 20px 20px;
  margin: 20px auto;
}

.operate-container {
  background: #f2f6fc;
  height: 80px;
  margin: -20px -20px 0;
  line-height: 80px;
}

.operate-button-container {
  float: right;
  margin-right: 20px;
}

.table-layout {
  margin-top: 10px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  line-height: 19px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 12px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  white-space: pre-wrap;
  /* overflow: hidden; */
  height: 43px;
}

.table-cell-title {
  height: 43px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 12px;
  background: #f2f6fc;
  text-align: center;
  font-size: 14px;
  color: #303133;
  font-weight: 650;
}

.el-table th.gutter {
  display: table-cell !important;
}

.el-button+.el-button {
  margin-left: 0px;
}

.el-table colgroup.gutter {
  display: table-cell !important;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.color-danger {
  color: #f56c6c;
  font-size: 18px;
}

.el-dialog .el-cascader {
  width: 400px;
}

.fixed-width .el-button--mini {
  width: auto;
  min-width: 60px;
}

.el-step.is-center .el-step__description {
  padding-left: 18%;
  padding-right: 18%;
}

.el-table th.gutter {
  display: table-cell !important;
}
</style>
